module.exports = "<div class=\"container text-center\" style=\"padding-bottom: 20px\">\r\n  <div class=\"content-404\">\r\n    <img src=\"img/404.png\" class=\"img-responsive\" alt=\"\" />\r\n    <h1><b>OPPS!</b> No pudimos encontrar esta página</h1>\r\n    <p>Uh ... Por lo tanto, parece que la página que estás buscando ha desaparecido.</p>\r\n    <h2><a href=\"/\">Regresar a la pagina principal</a></h2>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/menssage/notFound/404.html
// module id = 582
// module chunks = 1